/* eslint-disable no-debugger */
import { getRouteWithParam, ROUTES } from '../constants/routes';
import { SEARCH_CUSTOMER_BY } from '../constants/variables';
import { useHistory, useParams } from 'react-router-dom';

const IIN = 'IIN';
const PHONE = 'PHONE';
const LC = 'LC';

export const useSearchCustomerBy = () => {
  const history = useHistory();
  const params = useParams();

  const getParams = (values) => {
    if (params?.iin || values?.by?.value === SEARCH_CUSTOMER_BY[0].value) {
      return {
        params: { iin: +params?.iin || values?.mobile_phoneOrIIN },
        search_type: IIN
      };
    }

    if (params?.mobile_phone || values?.by?.value === SEARCH_CUSTOMER_BY[1].value) {
      return {
        params: {
          mobile_phone: +params?.mobile_phone || values?.mobile_phoneOrIIN,
          search_type: +params.search_type || values?.search_type?.value
        },
        search_type: PHONE
      };
    }

    if (params?.local_id || values?.by?.value === SEARCH_CUSTOMER_BY[2].value) {
      return {
        params: {
          local_id: +params?.local_id || values?.mobile_phoneOrIIN,
          branch_id: +params.branch_id || values?.search_type?.value
        },
        search_type: LC
      };
    }
  };

  const redirectToUserCard = (searchBy, id) => {
    if (searchBy.search_type === IIN) {
      history.push(
        getRouteWithParam(
          ROUTES.SUPPORT_USER_CARD_BY_INN,
          ':iin/:id',
          `${searchBy.params.iin}/${id}`
        )
      );
    }

    if (searchBy.search_type === PHONE) {
      history.push(
        getRouteWithParam(
          ROUTES.SUPPORT_USER_CARD_BY_PHONE,
          ':mobile_phone/:search_type/:id',
          `${searchBy.params.mobile_phone}/${searchBy.params.search_type}/${id}`
        )
      );
    }

    if (searchBy.type === LC) {
      history.push(
        getRouteWithParam(
          ROUTES.SUPPORT_USER_CARD_BY_LC,
          ':local_id/:branch_id/:id',
          `${searchBy.params.local_id}/${searchBy.params.branch_id}/${id}`
        )
      );
    }
  };

  const createPath = (route) => {
    if (params?.iin) {
      const findRoute = Object.values(ROUTES).find((path) => path.includes(`${route}/:iin`));
      return getRouteWithParam(findRoute, ':iin/:id', `${params?.iin}/${params?.id}`);
    }

    if (params?.mobile_phone) {
      const findRoute = Object.values(ROUTES).find((path) =>
        path.includes(`${route}/:mobile_phone`)
      );
      return getRouteWithParam(
        findRoute,
        ':mobile_phone/:type/:id',
        `${params?.mobile_phone}/${params?.search_type}/${params?.id}`
      );
    }

    if (params?.local_id) {
      const findRoute = Object.values(ROUTES).find((path) => path.includes(`${route}/:local_id`));
      return getRouteWithParam(
        findRoute,
        ':local_id/:branch_id/:id',
        `${params?.local_id}/${params?.branch_id}/${params?.id}`
      );
    }
  };

  return { getParams, redirectToUserCard, createPath };
};
